import { Color, Text } from "src/elements";
import { useTranslation } from "src/i18n";
import { useCdtCategoryStoresQuery } from "src/pages/CDTTreeEditor/store/useCdtCategoryStoresQuery";
import { useCdtCategoryTreesQuery } from "src/pages/CDTTreeEditor/store/useCdtCategoryTreesQuery";

interface Props {
  categoryId: number;
  /**
   * Loads only once armed (the card was hovered), so the Categories page does
   * not fire two requests per category on load. Replace with the summary
   * endpoint once it exists (DEV-3062).
   */
  isArmed: boolean;
}

/** "N versions · M stores pinned" under a category's Decision Trees button. */
export const CdtVersionSummary = ({ categoryId, isArmed }: Props) => {
  const { t } = useTranslation("common");
  const treesQuery = useCdtCategoryTreesQuery(isArmed ? categoryId : undefined);
  const storesQuery = useCdtCategoryStoresQuery(isArmed ? categoryId : undefined);

  if (!treesQuery.data || !storesQuery.data) {
    return (
      <Text variant="small4" color={Color.textSecondary}>
        {isArmed && (treesQuery.isLoading || storesQuery.isLoading)
          ? t("cdtCategorySummary.loading")
          : " "}
      </Text>
    );
  }

  const versions = treesQuery.data.length;
  const pinned = storesQuery.data.filter((store) => !store.isDefaultFallback).length;

  return (
    <Text variant="small4" color={Color.textSecondary}>
      {t("cdtCategorySummary.summary", {
        versions,
        versionLabel: t(
          versions === 1 ? "cdtCategorySummary.version" : "cdtCategorySummary.versions",
        ),
        pinned,
        pinnedLabel: t(pinned === 1 ? "cdtCategorySummary.store" : "cdtCategorySummary.stores"),
      })}
    </Text>
  );
};
